import api from "../../../api/index";

export function discountCodes(){
    return api.get(`discount-codes`)
}

export function addDiscount(payload){
    return api.post(`discount-code`, payload)
}

export function deleteDiscount(id){
    return api.delete(`discount-code/${id}`);
}